export default __webpack_public_path__ + "book_details-language.5df69386.png";